

















import { listFactory } from '@/main/pages';

import { previewButton } from '@/main/utils/tableOperations';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
import { DokladNaplnFakturaci } from '@/modules/uctenky/fakturace/constants';
import { Fakturace } from '@/modules/uctenky/fakturace';

import { apiProvider as pratnerApiProvider } from '@/modules/kartoteka/partner/api';

import { apiProvider } from './api';
import { store } from './store/list';
import { NAME, STATUS_APPROVED, STATUS_REJECTED } from './constants';

export default listFactory(NAME, store).extend({
	beforeDestroy() {
	},
	data() {
		return {
			ApproverData: [] as any,
			IsApprover: false as boolean | null,
			Approvaldata: {
				data: false,
			},
		};
	},
	computed: {
		extraButtons(): {} {
			return {
				...previewButton(this.viewDetailsClick),
			};
		},
	},
	methods: {
		async viewDetailsClick(e: any, cells: any) {
			if (cells[this.table.cellNames!.REQUEST_STATUS_ID] === STATUS_APPROVED || cells[this.table.cellNames!.REQUEST_STATUS_ID] === STATUS_REJECTED) {
				return;
			}
			if (this.dmsSys.IsCancelInvoicePrp) {
				const custId = cells[this.table.cellNames!.ZAKAZNIK_ID];
				this.startLoading();
				if (custId!) {
					this.Approvaldata = await pratnerApiProvider.getOemApproval(custId);
				}

				this.endLoading();
				if (this.Approvaldata.data) {
					this.startLoading();
					this.ApproverData = await apiProvider.getWorkflowApprovalConfig('AreaManagerApproval', 'User');
					if (this.ApproverData.data.length > 0) {
						this.IsApprover = true;
					} else if (this.ApproverData.data[0].PrimaryApprovalId === this.pracovnik.PracovnikId) {
						this.IsApprover = true;
					}
				} else {
					this.startLoading();
					this.ApproverData = await apiProvider.getWorkflowApprovalConfig('DealerManagerAp', 'User');
					if (this.ApproverData.data.length > 0) {
						this.IsApprover = true;
					} else if (this.ApproverData.data[0].PrimaryApprovalId === this.pracovnik.PracovnikId) {
						this.IsApprover = true;
					}
				}
				this.endLoading();
				openEdit(Fakturace.name, PageMode.CREATE, {
					filter: {
						dokladId: cells[this.table.cellNames!.INVOICE_ID],
						dokladNaplnFakturaci: DokladNaplnFakturaci.DOBROPIS,
						isapprover: this.IsApprover,
						rrId: cells[this.table.cellNames!.ID],
						CRNo: cells[this.table.cellNames!.X_KDOKLAD_NR],
						statusId: cells[this.table.cellNames!.REQUEST_STATUS_ID],
						orderType: cells[this.table.cellNames!.ZAKAZKA_DRUH],
						createdById: cells[this.table.cellNames!.CREATED_BY_ID],
					},
				});
			}
		},
	},
});
